// @import dependencies
import React, {Component} from 'react'
// @end

// @import components
import {BlogsScreenLayout} from 'app_components/screens/landing/blogs'
// @end

// @ADD Component types
interface IBlogsScreenProps {}
interface IBlogsScreenState {}

class BlogsScreen extends Component<IBlogsScreenProps, IBlogsScreenState> {

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor(props: IBlogsScreenProps) {
    super(props)
    this.state = {}
  }

  render() {
    return(
      <BlogsScreenLayout
        {...this.props}
      />
    )
  }
}

export default BlogsScreen
